import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext'; // Import useAuth hook
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import LoginModal from './LoginModal'; // Import the LoginModal component

const HeroSection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { authData } = useAuth(); // Access authData from AuthContext
    const navigate = useNavigate(); // Initialize navigation

    const handleLoginClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleDashboardClick = () => {
        navigate('/dashboard'); // Navigate to the dashboard view
    };

    return (
        <div>
            <nav class="gradient-bg text-white shadow-lg fixed top-0 w-full z-50">
                <div class="container mx-auto px-4 py-3 flex justify-between items-center">
                    <a href="#features" class="flex items-center space-x-2">
                        <img
                            src="/logo_nb.png" // Reference the logo from the public folder
                            alt="StockEasy Logo"
                            class="h-12" // Adjust the height as needed
                        />
                        <span class="text-xl font-bold">StockEasy</span>
                    </a>
                    <div class="hidden md:flex space-x-6">
                        <a href="#features" class="hover:text-blue-200 transition">Features</a>
                        <a href="#how-it-works" class="hover:text-blue-200 transition">How It Works</a>
                        <a href="#contact" class="hover:text-blue-200 transition">Contact</a>
                    </div>
                    {authData ? (
                        <button
                            id="dashboardBtn"
                            class="bg-white text-blue-600 px-4 py-2 rounded-lg font-medium hover:bg-blue-50 transition"
                            onClick={handleDashboardClick}
                        >
                            Dashboard
                        </button>
                    ) : (
                        <button
                            id="loginBtn"
                            class="bg-white text-blue-600 px-4 py-2 rounded-lg font-medium hover:bg-blue-50 transition"
                            onClick={handleLoginClick}
                        >
                            Login
                        </button>
                    )}
                    <button class="md:hidden text-2xl" id="mobileMenuBtn">
                        <i class="fas fa-bars"></i>
                    </button>
                </div>
                <div id="mobileMenu" class="hidden md:hidden bg-blue-900 px-4 py-2">
                    <a href="#features" class="block py-2 hover:text-blue-200 transition">Features</a>
                    <a href="#how-it-works" class="block py-2 hover:text-blue-200 transition">How It Works</a>
                    <a href="#contact" class="block py-2 hover:text-blue-200 transition">Contact</a>
                </div>
            </nav>

            {isModalOpen && <LoginModal onClose={handleCloseModal} />}
        </div>
    );
};

export default HeroSection;